import React, { useState,useRef  } from "react"
import "./EditCategory.scss"
import { useLocation, useNavigate } from "react-router-dom"
import { Button, Card, CardBody, Col, Row, Spinner } from "reactstrap"
import { InputText } from "primereact/inputtext"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import CategoryApi from "Api/CategoryApi"
import * as Yup from "yup"
import { Dropdown } from "primereact/dropdown"
import { Toast } from 'primereact/toast'

const EditCategory = () => {
  document.title = "Edit Category"
  const [loading, setLoading] = useState(false)
  const toast = useRef(null);
  const navigate = useNavigate("")
  const accessToken = localStorage.getItem("accessToken")
  const location = useLocation()
  const category = location?.state
  const userData = JSON.parse(localStorage.getItem("userData"))

  const refinedCatgeoryData = {
    ...category,
    verifiedStatus: {
      name:
        category?.verifiedStatus.charAt(0)?.toUpperCase() +
        category?.verifiedStatus?.slice(1),
      code:
        category?.verifiedStatus.charAt(0)?.toUpperCase() +
        category?.verifiedStatus?.slice(1),
    },
    verifiedReason: category?.verifiedReason ? category?.verifiedReason : "",
  }

  console.log(refinedCatgeoryData)

  const [catgeoryData, setCategoryData] = useState(refinedCatgeoryData)
  const [errors, setErrors] = useState({})

  const handleCategoryDataChange = (name, value) => {
    setCategoryData(prevState => ({
      ...prevState,
      [name]: value,
    }))
    setErrors({ ...errors, [name]: "" })
  }

  const verficationOption = [
    { name: "Approve", code: "Approve" },
    { name: "Reject", code: "Reject" },
    { name: "Pending", code: "Pending" },
  ]

  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "Category", link: "#" },
    { label: "Edit Category", link: "#" },
  ]

  const ValidateCourse = Yup.object().shape({
    categoryName: Yup.string().required("University is required"),
    categoryName: Yup.string().required("Institution is required"),
  })

  const saveCategory = () => {
    const payload = {
      ...catgeoryData,
      verifiedStatus: catgeoryData?.verifiedStatus?.code?.toLowerCase(),
    }

    console.log(payload)

    setLoading(true)

    ValidateCourse.validate(payload, { abortEarly: false })
      .then(() => {
        const config = {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
        CategoryApi.updateCategory(payload, config)
          .then(res => {
            setLoading(false)

            if (res.data.status) {
              setTimeout(()=>{
                navigate("/categoryList")
              },1000)
              toast.current.show({severity:'success', summary: 'Success', detail: res.data.message, life: 3000});
             
            }
          })
          .catch(error => {
            setLoading(false)
            console.log(error)
            toast.current.show({severity:'error', summary: 'Error', detail: error.response.data.message, life: 3000});
          })
      })
      .catch(err => {
        setLoading(false)
        const validationErrors = {}
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message
        })
        setErrors(validationErrors)
        toast.current.show({severity:'error', summary: 'Error', detail: "Please fill all the required fields correctly!", life: 3000});
      })
  }

  return (
    <div className="edit-category">
      <Toast ref={toast} />
      <Row>
        <Col xs="12">
          <div className="category-list-header d-flex  align-items-center justify-content-between">
            <CustomBreadCrumb
              data={breadcrumbItems}
              pageTitle="Edit Category"
            />
          </div>

          <Card className="mt-4 ">
            <CardBody>
              <div className="category-edit-form ">
                <div className="category-edit-inp">
                  <label htmlFor="categoryName" className="label">
                    Category Name
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="categoryName"
                      value={catgeoryData.categoryName}
                      onChange={e =>
                        handleCategoryDataChange("categoryName", e.target.value)
                      }
                      placeholder="Enter Catgeory Name"
                      className="inp-field-box"
                    />
                    {errors.categoryName && (
                      <small className="error">{errors.categoryName}</small>
                    )}
                  </div>
                </div>
                <div className="category-edit-inp">
                  <label htmlFor="description" className="label">
                    Description
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="description"
                      value={catgeoryData.description}
                      onChange={e =>
                        handleCategoryDataChange("description", e.target.value)
                      }
                      placeholder="Enter Description"
                      className="inp-field-box"
                    />
                    {errors.description && (
                      <small className="error">{errors.description}</small>
                    )}
                  </div>
                </div>
                {userData.role === "manager" && (
                  <>
                    <div className="category-edit-inp">
                      <label htmlFor="verifiedStatus" className="label">
                        Verification
                      </label>
                      <div className="inp-err ">
                        <Dropdown
                          id="verifiedStatus"
                          value={catgeoryData.verifiedStatus}
                          onChange={e =>
                            handleCategoryDataChange("verifiedStatus", e.value)
                          }
                          options={verficationOption}
                          optionLabel="name"
                          placeholder="Select Verification Status"
                          className="inp-field-box"
                        />
                        {errors.verifiedStatus && (
                          <small className="error">
                            {errors.verifiedStatus}
                          </small>
                        )}
                      </div>
                    </div>

                    <div className="category-edit-inp">
                      <label htmlFor="verifiedReason" className="label">
                        Verification Reason
                      </label>
                      <div className="inp-err">
                        <InputText
                          id="verifiedReason"
                          value={catgeoryData.verifiedReason}
                          onChange={e =>
                            handleCategoryDataChange(
                              "verifiedReason",
                              e.target.value,
                            )
                          }
                          placeholder="Enter Verification Reason"
                          className="inp-field-box"
                        />
                        {errors.verifiedReason && (
                          <small className="error">
                            {errors.verifiedReason}
                          </small>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div className="save-cancel-btn mt-4 d-flex align-items-center justify-content-end gap-3">
                <Button
                  type="button"
                  outline
                  color="danger"
                  className="waves-effect waves-light"
                  onClick={() => {
                    navigate(-1)
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  color="secondary"
                  className="waves-effect waves-light"
                  onClick={() => {
                    saveCategory()
                  }}
                >
                  {loading ? <Spinner size="sm" /> : "Update"}
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default EditCategory
